import { TextField } from "@project/shared/src/components/atom"
import { UploadComponent } from "@project/shared/src/components/atom/Upload"
import { useFormik } from "formik"
import styled from "styled-components"
import { Descripition, Headline, StyledGradientTitle } from "../../../utils"
import { Button } from "../../atoms"

const Wrapper = styled.div`
  padding: 80px;
  background: ${(props) => props.theme.footerSectionColor};
  @media (max-width: 641px) {
    padding: 50px 20px;
  }
`

const StyledGradientTitleText = styled(StyledGradientTitle)`
  @media (max-width: 567px) {
    font-size: 1.25rem;
  }
`
const DescripitionText = styled(Descripition)`
  font-size: 1rem;
  color: #ffffffcc;
  width: 55%;
  margin: 0 auto;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 40px;
  @media (max-width: 1023px) {
    width: 100%;
  }
`

const FormCardWrapper = styled.div`
  margin: auto;
  max-width: 862px;
  min-height: auto;
  border: 1px solid #282f47;
  background-color: ${(props) => props.theme.historyCardGradient};
  padding: 32px;
  border-radius: 40px;

  @media (max-width: 500px) {
    padding: 20px 20px;
  }
`

const InputFieldWrapper = styled.div`
  margin-bottom: 20px;
  & .text-area {
    width: 100%;
    color: ${(props) => props.theme.baseTextColor};
    .ant-input-affix-wrapper {
      background-color: "#202534";
      color: ${(props) => props.theme.base};
      :hover {
        border: 1px solid ${(props) => props.theme.base};
      }
    }
    .ant-input {
      padding: 6px 16px;
      line-height: 38px;
      background-color: #202534;
      border-color: ${(props) => props.theme.searchBarBorderColor};
      color: ${(props) => props.theme.base};
      font-size: 1rem;
      border-radius: 5px;
      @media (max-width: 1023px) {
        font-size: 0.875rem;
      }
    }
  }
  & .text-field {
    width: 100%;
    color: ${(props) => props.theme.baseTextColor};
    font-size: 1rem;

    .ant-input-affix-wrapper {
      background-color: #202534;
      color: ${(props) => props.theme.base};
      :hover {
        border: 1px solid ${(props) => props.theme.base};
      }
    }
    .ant-input {
      background-color: #202534;
      color: ${(props) => props.theme.base};
      font-size: 1rem;
      height: 50px;
      padding: 6px 16px;
      border-radius: 5px;
      border-color: ${(props) => props.theme.searchBarBorderColor};
      @media (max-width: 1023px) {
        height: 38px;
        padding: 12px;
        font-size: 0.875rem;
      }
    }
  }
`
const TextFieldWrapper = styled(TextField)`
  & > div > div {
    font-size: 1rem;
    @media (max-width: 1023px) {
      font-size: 0.875rem;
    }
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: flex-end;
  gap: 20px;

  @media (max-width: 576px) {
    button {
      height: 38px;
    }
  }
`
const ButtonContainer = styled(Button)`
  width: 185px;
  @media (max-width: 576px) {
    & > span {
      font-size: 0.75rem;
    }
  }
`

const UploadComponentWrapper = styled(UploadComponent)`
  color: white;
  & .label {
    font-size: 0.875rem;
  }
  .ant-upload-text {
    font-size: 1rem !important;
  }
  .ant-upload-hint {
    font-size: 0.875rem !important;
  }

  @media (max-width: 576px) {
    .ant-upload-text {
      font-size: 0.875rem !important;
    }

    .ant-upload-hint {
      font-size: 0.75rem !important;
    }
  }
`

const ApplicationSection: React.FC = () => {
  const formik = useFormik({
    initialValues: {},
    onSubmit: () => {
      //handleContactForm()
    },
  })
  return (
    <Wrapper id="job-apply-form">
      <Headline>
        <StyledGradientTitleText>{"Connect "}</StyledGradientTitleText>
        {"with us effortlessly"}
      </Headline>
      <DescripitionText>
        {
          "We don't currently have any active job postings, but new opportunities open up regularly. Leave your CV below to be notified the moment something matches your profile."
        }
      </DescripitionText>
      <FormCardWrapper>
        <form>
          <InputFieldWrapper>
            <TextFieldWrapper
              label={"Full Name"}
              name={"username"}
              className={"text-field"}
              placeholder={"Your full name"}
              bordercolor="#313952"
              placeholdercolor="#FFFFFF99"
            />
          </InputFieldWrapper>

          <InputFieldWrapper>
            <TextFieldWrapper
              label={"Email address"}
              name={"email"}
              className={"text-field"}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              placeholder={"Your email address"}
              bordercolor="#313952"
              placeholdercolor="#FFFFFF99"
            />
          </InputFieldWrapper>

          <InputFieldWrapper>
            <TextFieldWrapper
              label={"Phone Number"}
              name={"number"}
              className={"text-field"}
              placeholder={"Your phone number"}
              bordercolor="#313952"
              placeholdercolor="#FFFFFF99"
            />
          </InputFieldWrapper>
          <UploadComponentWrapper
            labelText={"Upload Your CV"}
            borderColor={"#313952"}
            labelColor={"#fff"}
          />
          <InputFieldWrapper>
            <TextFieldWrapper
              label={"Tell us more about your concern"}
              name={"inquiry"}
              type={"textarea"}
              className={"text-area"}
              rows={4}
              maxLength={500}
              showCounting={true}
              placeholder={"Write your inquiry here"}
              bordercolor="#313952"
              placeholdercolor="#FFFFFF99"
            />
          </InputFieldWrapper>
          <ButtonWrapper>
            <ButtonContainer buttonType={"secondary"} onClick={() => null}>
              {"Apply"}
            </ButtonContainer>
          </ButtonWrapper>
        </form>
      </FormCardWrapper>
    </Wrapper>
  )
}

export { ApplicationSection }
